var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRefresh = function SvgRefresh(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66683 7.00052C1.66683 5.44719 2.34683 4.05385 3.4135 3.08052L5.00016 4.66719V0.667188H1.00016L2.46683 2.13385C1.16016 3.34719 0.333496 5.07385 0.333496 7.00052C0.333496 10.4605 2.96683 13.3005 6.3335 13.6339V12.2872C3.70683 11.9605 1.66683 9.71385 1.66683 7.00052ZM13.6668 7.00052C13.6668 3.54052 11.0335 0.700521 7.66683 0.367188V1.71385C10.2935 2.04052 12.3335 4.28719 12.3335 7.00052C12.3335 8.55385 11.6535 9.94719 10.5868 10.9205L9.00016 9.33385V13.3339H13.0002L11.5335 11.8672C12.8402 10.6539 13.6668 8.92719 13.6668 7.00052Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRefresh, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/refresh.0f67b6f5.svg";
export { ForwardRef as ReactComponent };